/* TODO: Move to model action? */

export function flatten_sequence( sequenceItemList, include_source = true ) {

  let action_list = []
  if (sequenceItemList) {
    sequenceItemList.forEach( ( sequenceItem, itemIdx ) => {
      let actions = sequenceItem.actions.map( ( action, actionIdx ) => {
        return {
          ...action,
          description: sequenceItem.title, // TODO !!!
          sequenceItemId: itemIdx + ':' + actionIdx,
          /* Template source */
          source: include_source ? {
            id: sequenceItem.id,
            groupId: sequenceItem.groupId,
            title: sequenceItem.title,
          } : null
        }
      });
      action_list = action_list.concat( actions )
    });
  }

  return action_list;
}
